var _style, _path, _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7,25.6c-0.2-0.1-0.5-0.1-0.8-0.1c0.1-0.2,0.1-0.3,0.2-0.4c0.6-1.5,1.3-3,1.9-4.4c0.2-0.4,0.2-0.8-0.1-1.1 c-0.5-0.5-1.2-0.4-1.5,0.3c-0.8,1.8-1.5,3.6-2.3,5.3c-0.1,0.1-0.2,0.3-0.3,0.3c-0.6,0-1.2,0-1.8,0c0.1-0.2,0.1-0.3,0.2-0.5 c0.6-1.5,1.3-2.9,1.9-4.4c0.2-0.5,0.2-0.8-0.1-1.1c-0.5-0.5-1.2-0.4-1.5,0.3c-0.8,1.8-1.5,3.5-2.3,5.3c-0.1,0.3-0.3,0.4-0.6,0.4 c-2.7,0-5.3,0-8,0c-0.4,0-0.8-0.1-1.1-0.4c-0.3-0.3-0.6-0.5-0.9-0.7c-2.6-1.7-5.5-2.2-8.5-2.1c-0.6,0-1.1,0.1-1.8,0.1 c-0.1,1-0.1,2-0.1,3.1c-0.1,0-0.2,0-0.3,0c-2.6,0.3-4.6,2.5-4.9,5.2c-0.2,1.8,0.1,3.6,0.5,5.3c2.8,12.1,15.2,18.6,25.7,13.2 c7-3.5,10.5-9.7,10.7-17.9C54,28.6,52.2,26.2,49.7,25.6z M48,27.6c0.1-0.2,0.2-0.3,0.5-0.3c1.7,0.1,2.9,0.9,3.5,2.5 c0.6,1.6,0.3,3.2-0.9,4.4c-0.6,0.6-1.3,1-2.1,1.1c-1.4,0.1-2.9,0-4.4,0c0.4-0.9,0.7-1.7,1.1-2.6C46.5,31,47.3,29.3,48,27.6z  M44.1,27.7c0.1-0.3,0.3-0.4,0.6-0.4c0.5,0,1,0,1.5,0c-0.1,0.2-0.1,0.3-0.2,0.4c-1.1,2.4-2.1,4.9-3.2,7.3c-0.1,0.3-0.2,0.4-0.5,0.4 c-0.5,0-1,0-1.6,0c0.1-0.2,0.1-0.3,0.2-0.5C42,32.5,43,30.1,44.1,27.7z M35.6,27.3h6.7c-0.1,0.2-0.1,0.3-0.2,0.4 C41.1,30.2,40,32.6,39,35c-0.1,0.2-0.2,0.3-0.5,0.3c-1.2,0-2.3,0-3.5,0C36.5,32.8,36.9,30.1,35.6,27.3z M24.1,24 c1,0.1,1.9,0.1,2.9,0.2c1.9,0.2,3.7,0.8,5.2,2c1.2,0.9,2,2,2.3,3.5c0.3,1.6-0.1,3.1-0.9,4.4c0,0.1-0.1,0.1-0.2,0.2 c-2.3,1.5-4.9,1.5-6.9-0.9c-1.3-1.6-1.9-3.4-2.2-5.5c-0.2-1.1-0.2-2.3-0.3-3.5C24,24.4,24,24.3,24.1,24z M22.1,27.3 c0.1,0,0.2,0,0.3,0c0.4,3,1.2,5.8,3.4,8c-0.4,0-0.7,0-1,0c-0.8,0-1.7,0-2.5,0c-1.9-0.1-3.4-1.9-3.5-3.9 C18.7,29.4,20.2,27.5,22.1,27.3z M35.5,49.2c-8.5,0-14.6-6.6-16-12.9c1.1,0.8,2.4,1,3.7,1c7.9,0,15.8,0,23.8,0c1.6,0,3.2,0.1,4.6-1 C50,42.6,44,49.2,35.5,49.2z"
  })), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "other - services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 11.016480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.694777, 0.913268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeals);
export default __webpack_public_path__ + "static/media/meals.42b5d3cd.svg";
export { ForwardRef as ReactComponent };